import { z } from "zod";

export const ProjectSchema = z.object({
    id: z.number().positive().min(1),
    accountId: z.number().positive().min(1),
    name: z.string().max(128),
    createdBy: z.number().positive().min(1),
    createdOn: z.date(),
    modifiedBy: z.number().positive().min(1),
    modifiedOn: z.date(),
    lat: z.number().nullish(),
    lng: z.number().nullish(),
    description: z.string().max(4096).nullish(),
    ownerId: z.number().positive().min(1),
    startDate: z.preprocess((val) => (typeof val === "string" ? new Date(val) : val instanceof Date ? val : undefined), z.date().optional()),
    endDate: z.preprocess((val) => (typeof val === "string" ? new Date(val) : val instanceof Date ? val : undefined), z.date().optional()),
    deleted: z.boolean(),
    closed: z.boolean(),
})

export type Project = z.infer<typeof ProjectSchema>;

